// Copyright (c) 2018 Deere & Company

import ActionsPopoverCallback from '../../../shared/state/actions-popover-callback';

const createCallBack = (label, onOptionClick, onOptionClickValues) =>
    new ActionsPopoverCallback({
        label,
        onOptionClick,
        onOptionClickValues
    });

export const getPrintAuditOptions = (onPrintClaims, onPrintCreditMemos) => {

    const options = [];

    options.push(createCallBack('CLAIMS', onPrintClaims));
    options.push(createCallBack('CREDIT_MEMOS', onPrintCreditMemos));

    return options;

};



// WEBPACK FOOTER //
// ./src/tcsm/shared/services/get-print-audit-options.js